module.exports = __webpack_public_path__ + "img/iphone-installed.a91abc48.gif";